import React, { Component } from 'react';
import deleteNote from '../../resources/images/estrategas/tools/trash.png';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { NEW_BUSINESS_NOTE } from '../../utils/constants';


class DeleteNote extends Component {

  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.deleteNote = this.deleteNote.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { modal: false, note:'' };
  }

  toggleModal(){
    this.setState({ modal: !this.state.modal });
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  deleteNote(){

    Request.deleteFetch(NEW_BUSINESS_NOTE + '/' + this.props.id).then(()=>{
      this.props.callbackFromParent(Math.random());
      this.toggleModal()
    })

  }

  render() {
    let classUser = this.props.authorization ? 'add-notes-icon' : 'quality-edit-unauthorized';
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={this.props.className}>
          <ModalHeader className='header-modal' toggle={this.toggleModal}/>
          <ModalBody>
            <h4>¿Esta seguro que deséa eliminar esta nota?</h4>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteNote}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggleModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className={classUser} onClick={this.toggleModal}>
          <img src={deleteNote} title='Agregar nota' alt=''/>
        </div>
      </div>
    );
  }
}

export default DeleteNote;



// WEBPACK FOOTER //
// ./src/components/buttons/deleteNoteNewBusienss.js